import { BaseDrawOption } from '@/modules/ta/widget/models/drawoptions/BaseDrawOption';

export class AccountManagerDrawOption extends BaseDrawOption {}
